/**
 * v2 路由配置
 * @description Vue Router 路由配置，支持路由懒加载、权限控制和基础导航
 */
import { createRouter, createWebHistory } from 'vue-router'
import { doneProgress, startProgress } from '@/utils/nprogress'
import { configGuard } from './guards/configGuard'
import routes from './routes'

// 创建路由实例
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  // 路由滚动行为
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // 平滑滚动到顶部
    return {
      top: 0,
      behavior: 'smooth',
    }
  },
})

// 用于记录路由历史，实现前进/后退方向感知
const routeHistory: string[] = []

// 路由前置守卫 - 开始进度条
router.beforeEach(async (to, from, next) => {
  startProgress()

  // 路由过渡动画逻辑 (方向感知)
  const toIndex = routeHistory.indexOf(to.path)
  if (toIndex !== -1) {
    // 目标路径在历史中存在，说明是后退
    routeHistory.splice(toIndex + 1)
    to.meta.transition = 'slide-right'
  }
  else {
    // 前进
    routeHistory.push(to.path)
    to.meta.transition = from.path === '/' ? 'fade-slide' : 'slide-left'
  }

  // 初始加载或刷新，默认淡入滑动
  if (!from.name) {
    to.meta.transition = 'fade-slide'
  }

  // 配置检查守卫（维护模式、功能开关等）
  await configGuard(to, from, next)
})

// 路由后置守卫 - 结束进度条
router.afterEach(() => {
  doneProgress()
})

export default router
